import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {SharedImports} from '@shared/shared-imports';
import {UserSOICampaignDonationModel} from '@app/models/user-soi-campaign-donation.model';
import {SOICampaignModel} from '@app/models/soi-campaigns.model';

@Component({
    selector: 'app-campaign-page-4',
    templateUrl: './page-4-confirm.component.html',
    styleUrls: ['./page-4-confirm.component.scss'],
    imports: [
        SharedImports
    ]
})

export class Page4ConfirmComponent implements OnInit {
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() campaignProfile: UserSOICampaignDonationModel;
  @Input() orgCampaignDetails: SOICampaignModel;
  constructor(private router: Router, private location: Location) {

  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
  }

  goToNextPage() {
    this.next.emit();
  }

  goBack() {
    this.location.back();
  }
}

